export enum AppRoutes {
  OTHER = "/other",
  LOGIN = "/login",
  HOME = "/",
  ADMIN = "/admin",
  PDF = "/pdf",
  STOCK = "/stock/amount-available-per-product",
  STOCK_MANAGEMENT = "/stock-management",
  USER_MANAGEMENT = "/other/user-management",
  SHOP_MANAGEMENT = "/other/shop-management",
  DASHBOARD = "/",
  SETTINGS = "/other/settings",
  CONSUMPTION = "/consumption",
  ACTIVITY_LOG = "/other/activity-log",
}
